// extracted by mini-css-extract-plugin
export default {"input":"PhotoPicker_input__Bq9j5","slot":"PhotoPicker_slot__9WiQN","slotLabel":"PhotoPicker_slotLabel__gHbbe","slotOff":"PhotoPicker_slotOff__wI5PO"};